import React from 'react';
import {List} from 'react-admin';
import i18next from 'i18next';

import {RA_LIST_CUSTOM_STYLE} from '../../constants';
import ListPageLayout from '../../components/ListPageLayout';
import ProjectFilter from '../../components/ProjectFilter';
import {useSyncStoreToLocation} from '../../hooks/useSyncStoreToLocation';
import AnalyticsCharts from './components/AnalyticsCharts';

const STORE_KEY = 'analytics_filters';
const SORT = {field: 'nombre', order: 'ASC'} as const;
// The Acciones list's toolbar, without the margin it keeps around its table (the charts set their own).
// With no search box the filter form is empty until a filter is added; hidden, its margin doesn't push
// "Añadir filtro" off the content edge.
const ANALYTICS_STYLE = {
    ...RA_LIST_CUSTOM_STYLE,
    '& .RaList-content': {margin: 0, boxShadow: 'none', borderRadius: 0},
    '& .RaFilter-form:not(:has(.RaFilterForm-filterFormInput))': {display: 'none'},
    '&& .RaList-actions .MuiToolbar-root': {...RA_LIST_CUSTOM_STYLE['&& .RaList-actions .MuiToolbar-root'], paddingLeft: 0},
};

/**
 * The Analíticas page. A react-admin list only for its filters (kept in the URL, like the
 * Acciones list); the charts read them from the list context and show no records.
 */
const Analytics = () => {
    useSyncStoreToLocation({storeKey: STORE_KEY, sort: SORT, perPage: 1});

    return (
        <ListPageLayout title={i18next.t('projects-iirsa:analytics')}>
            <List
                resource="actions"
                storeKey={STORE_KEY}
                filters={<ProjectFilter hideSearch/>}
                sx={ANALYTICS_STYLE}
                exporter={false}
                pagination={false}
                perPage={1}
                sort={SORT}
                disableSyncWithLocation={false}
                empty={false}
                emptyWhileLoading={false}
            >
                <AnalyticsCharts/>
            </List>
        </ListPageLayout>
    );
};

export default Analytics;
